import {post} from '../HTTP';
import {saveUserData} from '../actions/loginActions';
import {saveUserDataToLS} from './utilityServices';
import {parseJwt} from '../utils/generalUtils';
import {IHistory} from '../interfaces';
import {showAlert} from '../actions/miscellaneousActions';

export async function loginUser(userID: string, password: string, history: IHistory, url: string, organizationId?: string) {
    try {
        const payload: any = { UserId: userID, UserPwd: password };
        if (organizationId) {
            payload.OrganizationId = organizationId;
        }
        const response = await post('/Login', payload);
        
        
        if (response?.requireMFA) {
            if (response?.otp_token) {
                localStorage.setItem('otp_token', response.otp_token);
                sessionStorage.setItem('otp_token', response.otp_token);
            }
            return response;
        }
        
        if (response?.StatusCode === 200) {
            return response;
        }
        
        throw new Error(response?.Message || response?.error || 'Login failed');
        
    } catch (error) {
        let errorText = 'Login failed';
        if (typeof error === 'string') {
            errorText = error;
        } else if (error?.message || error?.response?.data?.message) {
            errorText = error.message || error.response?.data?.message;
        }
        
        showAlert({
            title: 'Oops..!!',
            text: errorText,
            type: 'error',
            closeOnConfirm: true
        }, 'submission');
        
        throw error;
    }
}


export async function verifyOTP(userId: string, otp: string, organizationId?: string) {
    try {
        const otpToken = sessionStorage.getItem('otp_token');
        const payload: any = {
            userId: String(userId), 
            otp: String(otp),
            otp_token: otpToken
        };
        if (organizationId) {
            payload.OrganizationId = organizationId;
        }
        
        const response = await post('/VerifyOTP', payload);

        if (response?.success) {
            localStorage.removeItem('otp_token');
            sessionStorage.removeItem('otp_token');
        }
        
        return response;
        
    } catch (error) {
        console.error('verifyOTP error:', error);
        if ((error as any)?.response?.data) {
            return (error as any).response.data;
        }
        throw error;
    }
}

export async function resendOTP(userId: string) {
    try {
        const response = await post('/ResendOTP', {
            userId
        });

        if (response?.otp_token) {
            localStorage.setItem('otp_token', response.otp_token);
            sessionStorage.setItem('otp_token', response.otp_token);
        }
        
        return response;
        
    } catch (error) {
        console.error('resendOTP error:', error);
        showAlert({
            title: 'Oops..!!',
            text: error?.message || error?.response?.data?.message || 'Failed to resend OTP',
            type: 'error',
            closeOnConfirm: true
        }, 'submission');
        throw error;
    }
}

export async function forgotPassword(emailId) {
    try {
        await post('/ForgetPassword', {'UserId': emailId});
    } catch (e) {
        showAlert({
                title: 'Oops..!!',
                text: 'Invalid email. Try again with the correct one please..!!',
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw e;
    }
}

export async function resetPassword(data) {
    try {
        return await post('/ResetPassword', data);
    } catch (e) {
        showAlert({
                title: 'Oops..!!',
                text: 'Resetting password is failed, Please try again!',
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw e;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/loginService.ts